export default __webpack_public_path__ + "static/media/atrimony2.b6de35e9.jpg";